import { useInfiniteQuery } from "react-query";
import SearchService from "../api/services/SearchService";

export interface ISearchResultItem {
  application_instructions: string;
  base_name: string;
  bond_amount: number;
  bond_amount_descr: string;
  bond_amount_max: number;
  bond_amount_min: number;
  bond_amount_type: string;
  bond_preview_url: string;
  credit_bond: boolean;
  custom_expiration_details: string;
  custom_expiration_end_day: number;
  custom_expiration_end_month: number;
  custom_expiration_end_year: number;
  custom_expiration_grace_period_months: number;
  descr: string;
  effective_date_override: boolean;
  expiration_type: string;
  federal_bond: boolean;
  id: string;
  instant_issue: boolean;
  name: string;
  obligee_equals_principal: boolean;
  obligee_name: string;
  obligee_variable: boolean;
  offline_application: boolean;
  penalty_amount_variable: boolean;
  post_issue_instructions: string;
  production_ready: boolean;
  salesforce_product_link: string;
  slug: string;
  standard_expiration_term_months: number;
  state_code: string;
  top_100: boolean;
  type_id: string;
  website_page_id: string;
  __mso_data: any;
}

export const useSearch = (
  searchText: string,
  state: string,
  category: string
) => {
  return useInfiniteQuery(
    ["products", searchText, state, category],
    ({ pageParam }) =>
      SearchService.searchBond({
        states: state,
        groups: category,
        sort_by: "name,state_code",
        q: searchText,
        sort_dir: "ASC,ASC",
        offset: pageParam - 1 || 0,
        limit: 15,
      }),
    {
      keepPreviousData: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      enabled: true,
      getNextPageParam: (_lastPage, pages) =>
        pages.reduce((accum, { data, total_count }) => {
          const current = [...accum, ...data.products];
          if (total_count > current.length) {
            return current;
          }
          return false;
        }, []).length,
      select(data) {
        return data;
      },
    }
  );
};
